import React from 'react'
import ConfirmModal from '@bt-react/components/ConfirmModal'
import { GigStartConfirmModalProps } from './types'

class GigStartConfirmModal extends React.Component<GigStartConfirmModalProps> {

  componentDidMount () {

    if (!this.props.isLiveReady) {

      this.onCancel()
      return null

    }

  }

  componentDidUpdate (prevProps: GigStartConfirmModalProps) {

    this.toggleModalIfStatusChanges(prevProps)

  }

  toggleModalIfStatusChanges (prevProps: GigStartConfirmModalProps): void {

    if (prevProps.isLiveReady && !this.props.isLiveReady) {

      this.onCancel()

    }

  }

  onConfirm = (): void => this.props.onConfirm()

  onCancel = (): void => this.props.onCancel()

  render () {

    return <ConfirmModal
      isOpen={this.props.isOpen || false}
      content={{
        header: 'Are you sure you want to start?',
        body: 'On going live you will be seen and heard by your audience.',
        confirm: 'Yes, start talk now'
      }}
      onCancel={this.onCancel}
      onConfirm={this.onConfirm}
    />

  }

}

export default GigStartConfirmModal
